import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { PageHeader } from '~/src/components/PageHeader';

export const Status = () => {
  const { t } = useTranslation('overview');

  return (
    <Stack>
      <PageHeader title={t('status')} />
      <iframe
        height={'1000'}
        src="https://status.goshippo.com/"
        style={{ border: 'none', outline: 'none' }}
        title="API Status Page"
        width={'100%'}
      />
    </Stack>
  );
};
